$(document).ready( function() {

    let fileInput = $('.file__input');
    let fileBtn = $('.file__btn');
    let removeBtn = $(".file__delete");
    fileInput.change(function(){
        let filename = $(this).val().replace(/.*\\/, "");
        if(filename==''){
            $(this).next().text('Выберите файл');
        }else{
            $(this).next().text(filename);
            removeBtn.addClass("active");
            fileBtn.css("display","none");
        }
    });

    removeBtn.on('click', function () {
        fileInput.val("");
        fileInput.next().text("");
        removeBtn.removeClass("active");
        fileBtn.css("display","flex");
    });
});

$(".main__form").on("submit", (e)=>{
    e.preventDefault()
});

let checkboxs =$("#checkbox1,#checkbox2,#checkbox3");
let checkbox4 = $(".checkbox #checkbox4");

checkbox4.on('change', function () {
    if ($(this).prop('checked')) {
        checkboxs.prop('checked', false);
    }
});

checkboxs.on('change', function () {
    if ($(this).prop('checked')) {
        checkbox4.prop('checked', false);
    }
});

$( document ).ready( function (e) {

    $(".main__form").validate({
        rules: {
            brand: "required",
            product: "required",
            datactivate:"required",
            name:"required",
            textarea1:"required",
            textarea2:"required",
            textarea3:"required",
            textarea4:"required",
            textarea5:"required",
            textarea6:"required",
            textarea7:"required",
            textarea8:"required",
            contacts1:"required",
            contacts2:"required",
            contacts3:"required",
            contacts4:"required",

            file:"required",
            radio:"required",
            checkbox1:"required",

            // checkbox2:"required",
            // checkbox3:"required",
            // checkbox4:"required",

            budg:"required",
            company:"required",
            checked:"required",
            day: {
                required: true,
                minlength: 1,
                maxlength:31,
                number: true
            },
            month: {
                required: true,
                minlength: 1,
                maxlength:12,
                number: true
            },
            year: {
                required: true,
                // minlength: 2018,
                // maxlength:9999,
                number: true
            },
        },

        errorPlacement: function (error, element) {
            // Add the `help-block` class to the error element
            error.addClass("help-block");

            if (element.prop("type") === "checkbox") {
                error.insertAfter(element.parent("label"));
            } else {
                error.insertAfter(element);
            }
            if (element.prop("type") === "radio") {
                error.insertAfter(element.parent("label"));
            } else {
                error.insertAfter(element);
            }

            if(error) {
                $(".main__error").css("display","block")
            }
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass("error").removeClass("success");
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).addClass("success").removeClass("error");
        }
    });

});
$.validator.setDefaults( {
    submitHandler: function (e) {
        $(".yep").addClass("active");

        setTimeout(function () {
            $(".yep").removeClass("active");
        },5000);
    }
} );


let numInput = document.querySelector('.year #day');


numInput.addEventListener('input', function(){
    // Let match only digits.
    let num = this.value.match(/^\d+$/);
    if (num === null) {
        // If we have no match, value will be empty.
        this.value = "";
    }
}, false);

let numInput2 = document.querySelector('.year #month');


numInput2.addEventListener('input', function(){
    // Let match only digits.
    let num = this.value.match(/^\d+$/);
    if (num === null) {
        // If we have no match, value will be empty.
        this.value = "";
    }
}, false);

let numInput3 = document.querySelector('.year #year');


numInput3.addEventListener('input', function(){
    // Let match only digits.
    let num = this.value.match(/^\d+$/);
    if (num === null) {
        // If we have no match, value will be empty.
        this.value = "";
    }
}, false)